import PropTypes from 'prop-types';
import styles from './PatternTab.module.css';

// Client feedback 2026-08-06: vertical lays were rendering horizontal and
// vice-versa — swap the horizontal/vertical pattern IDs for both
// Straight Lay and Brick Pattern so the label matches what Chameleon draws.
// 2026-08-14: Brick horizontal and vertical share base pattern 176471;
// horizontal is distinguished by rotation code 254254 in the sel string
// (see BathFloor.jsx). Selection is tracked by `type` since ids collide.
const PATTERNS = [
    { id: 203043,  type: 'straight-lay-horizontal', name: 'Straight Lay Horizontal',  img: 'straight-lay-horizontal.svg' },
    { id: 148991,  type: 'straight-lay-vertical',   name: 'Straight Lay Vertical',    img: 'straight-lay-vertical.svg' },
    { id: 176471,  type: 'brick-pattern-horizontal', name: 'Brick Pattern Horizontal', img: 'running-bond-horizontal.svg' },
    { id: 176471,  type: 'brick-pattern-vertical',  name: 'Brick Pattern Vertical',   img: 'brick-pattern-vertical.svg' },
    { id: 0,       type: 'herringbone',              name: 'Herringbone',              img: 'herringbone.svg',       notVisualized: true },
    { id: 4769098, type: 'basketweave',              name: 'Basketweave',              img: 'basketweave.svg' },
    { id: 4769099, type: 'combination-lay',          name: 'Combination Lay',          img: 'combination-lay.svg' },
    { id: 0,       type: 'diamond',                  name: 'Diamond',                  img: 'diamond.svg',           notVisualized: true },
    { id: 214642,  type: '1-3-offset',               name: 'Offset Lay Vertical',      img: '1-3offset.svg' },
];

export default function PatternTab({ selectedPatternType, onPatternSelect }) {
    return (
        <div className={styles.grid}>
            {PATTERNS.map(p => (
                <button
                    key={`${p.type}-${p.id}`}
                    className={`${styles.item} ${selectedPatternType === p.type ? styles.active : ''}`}
                    onClick={() => onPatternSelect(p)}
                >
                    <img src={`/images/patterns/${p.img}`} alt={p.name} className={styles.thumb} />
                    <span className={styles.name}>{p.name}</span>
                    {p.notVisualized && <span className={styles.note}>(* Not Visualized)</span>}
                </button>
            ))}
        </div>
    );
}

PatternTab.propTypes = {
    selectedPatternType: PropTypes.string,
    onPatternSelect: PropTypes.func.isRequired
};
